export const WEB_SESSION_MARKER = '__icavi_web_cookie_session__';
export const WEB_SESSION_COOKIE_NAMES = ['__Host-icavi_session', 'icavi_session'];
export const WEB_CSRF_COOKIE_NAMES = ['__Host-icavi_csrf', 'icavi_csrf'];
const WEB_SESSION_MARKER_STORAGE_KEY = '__icavi_web_session_marker';
const isBrowser = () => typeof window !== 'undefined';
const readStoredUserData = () => {
    if (!isBrowser()) {
        return null;
    }
    const raw = localStorage.getItem('userData');
    if (!raw) {
        return null;
    }
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return null;
        }
        const sanitized = { ...parsed };
        const hadLegacyToken = Object.prototype.hasOwnProperty.call(sanitized, 'token') ||
            Object.prototype.hasOwnProperty.call(sanitized, 'access_token') ||
            Object.prototype.hasOwnProperty.call(sanitized, 'refresh_token');
        delete sanitized.token;
        delete sanitized.access_token;
        delete sanitized.refresh_token;
        if (hadLegacyToken) {
            try {
                localStorage.setItem('userData', JSON.stringify(sanitized));
            }
            catch {
                // A limpeza local não deve impedir a autenticação por cookie.
            }
        }
        return sanitized;
    }
    catch (error) {
        console.warn('Falha ao ler userData do localStorage:', error);
        return null;
    }
};
export const getWebSessionMarker = () => {
    if (!isBrowser()) {
        return null;
    }
    // A sessão Web é HttpOnly, portanto não pode ser detectada em document.cookie.
    // O marcador explícito é atualizado somente depois de uma resposta autenticada.
    const hasSessionCookie = document.cookie.split(';').some(cookie => {
        const normalizedCookie = cookie.trim();
        return WEB_SESSION_COOKIE_NAMES.some(name => normalizedCookie.startsWith(`${name}=`));
    });
    const hasExplicitMarker = localStorage.getItem(WEB_SESSION_MARKER_STORAGE_KEY) === '1';
    return hasSessionCookie || hasExplicitMarker ? WEB_SESSION_MARKER : null;
};
export const markWebSessionPresent = () => {
    if (isBrowser()) {
        localStorage.setItem(WEB_SESSION_MARKER_STORAGE_KEY, '1');
    }
};
export const clearWebSessionMarker = () => {
    if (isBrowser()) {
        localStorage.removeItem(WEB_SESSION_MARKER_STORAGE_KEY);
    }
};
export const resolveAuthSession = () => {
    if (!isBrowser()) {
        return {
            token: null,
            username: null,
            userData: null,
        };
    }
    const userData = readStoredUserData();
    const usernameRaw = userData?.username;
    const username = typeof usernameRaw === 'string' && usernameRaw.trim() ? usernameRaw.trim() : null;
    return {
        // Browser sessions use opaque HttpOnly cookies. Access/refresh tokens must
        // never be recovered from localStorage or copied into request headers.
        token: null,
        username,
        userData,
    };
};
